/* import __COLOCATED_TEMPLATE__ from './heartbeat-websocket-listener.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { later } from '@ember/runloop';
import { cancel } from '@ember/runloop';

export default class HeartbeatWebsocketListenerComponent extends Component
{
	@service socketGuru;
	@service errorManager;

	lastHeartbeatTime = null;
	timer = null;
	@tracked heartbeatErrorId = null;

	constructor()
	{
		super(...arguments);
		this._boundHandleSocketEvent = this._handleSocketEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleSocketEvent);
		// Only start heartbeat checking if not disabled (for testing)
		if (!this.args.disableHeartbeatCheck) {
			this.checkHeartbeat();
		}
	}

	willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleSocketEvent);
		cancel(this.timer);
		// Clear any heartbeat error on destroy
		if (this.heartbeatErrorId) {
			this.errorManager.removeError(this.heartbeatErrorId);
		}
		super.willDestroy();
	}

	_handleSocketEvent(event)
	{
		const { eventName, data } = event.detail;
		if(eventName == "heartbeat")
		{
			//console.log(`Message: ${data}`);
			this.lastHeartbeatTime = new Date();
			// Clear heartbeat error if it exists
			if (this.heartbeatErrorId) {
				this.errorManager.removeError(this.heartbeatErrorId);
				this.heartbeatErrorId = null;
			}
		}
	}

	checkHeartbeat()
	{
		if(this.lastHeartbeatTime != null)
		{
			//no heartbeat for 5 seconds
			if(new Date() - this.lastHeartbeatTime > 5000)
			{
				if (!this.heartbeatErrorId) {
					this.heartbeatErrorId = this.errorManager.addError(
						"Server connection lost",
						{ clearable: false, type: 'heartbeat' }
					);
				}
			}
		}
		this.timer = later(this,this.checkHeartbeat,1000);
	}
}